require('./localization/messages_ru');



// WEBPACK FOOTER //
// ./ru.js